import { createSelector } from 'reselect';
import { getSelectedElements } from '../../../../../element/selection/selectedElementsSelector';
import { elementGraphSelector } from '../../../../../element/selectors/elementGraphSelector';
import { isTaskList } from '../../../../../../common/elements/utils/elementTypeUtils';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { length } from '../../../../../../common/utils/immutableHelper';

export const canShowLabelsToolSelector = createSelector(
    getSelectedElements,
    elementGraphSelector,
    (selectedElements, elementGraph) => {
        if (selectedElements.size <= 1) return true;

        const selectedTaskLists = selectedElements.filter(isTaskList);
        if (selectedTaskLists.size === 0) return true;

        return selectedTaskLists.every((taskList: ImMNElement) => {
            const taskListId = getElementId(taskList);
            const childIds = elementGraph[taskListId];

            return length(childIds) === 1;
        });
    },
);
